export default [
  {
    "id": "premiers-pas",
    "category": "Prise en main",
    "title": "Se repérer et choisir son rôle",
    "roles": [],
    "path": "",
    "summary": "Retrouvez les outils utiles à votre métier sans parcourir toute l’application.",
    "steps": [
      "Ouvrez le menu de votre profil, en haut à droite. Le rôle sélectionné détermine les menus et les fonctions proposés.",
      "Si plusieurs rôles vous sont attribués, choisissez celui correspondant au travail à effectuer. Un rôle absent doit être attribué par un administrateur.",
      "Utilisez la barre latérale pour ouvrir une fonctionnalité. Les points verticaux d’une ligne donnent accès à ses actions.",
      "Ouvrez Guide d’utilisation en bas de la barre latérale. Recherchez un mot ou choisissez une rubrique ; le contenu suit votre rôle actif.",
      "Les nouveautés sont accessibles depuis l’icône étoilée du header. Elles dépendent de l’interface utilisée."
    ],
    "tip": "Changer de rôle ne crée pas de nouveaux droits. Si une rubrique manque, vérifiez aussi que vous êtes dans la bonne interface : Clinique, Caisse ou Stock."
  },
  {
    "id": "session",
    "category": "Prise en main",
    "title": "Résoudre une session expirée ou un chargement impossible",
    "roles": [],
    "path": "",
    "summary": "Comprendre les messages d’accès et reprendre une opération sans la créer deux fois.",
    "steps": [
      "Si le message indique une session expirée, reconnectez-vous dans l’interface concernée. La session Clinique et la session Caisse sont distinctes.",
      "Après connexion, rouvrez la fonctionnalité et utilisez Réessayer si ce bouton est proposé.",
      "Si l’accès est refusé, vérifiez votre rôle actif et contactez un administrateur. Ne modifiez pas les données pour contourner un refus d’accès.",
      "Après une erreur au moment d’une validation, consultez d’abord la liste ou l’historique pour savoir si l’opération a été enregistrée avant de recommencer.",
      "Si le problème persiste, transmettez au support le nom de l’écran, l’heure et le texte exact du message, sans mot de passe ni données médicales inutiles."
    ],
    "tip": "Une liste vide n’est pas toujours une panne : effacez les filtres de recherche, de date ou de statut. Ne multipliez pas les clics sur Enregistrer pendant un chargement."
  },
  {
    "id": "rechercher-imprimer",
    "category": "Prise en main",
    "title": "Rechercher, filtrer et imprimer un document",
    "roles": [],
    "path": "",
    "summary": "Retrouver rapidement une ligne et vérifier ce qui sera imprimé.",
    "steps": [
      "Saisissez un nom ou une référence dans le champ Rechercher de la liste concernée.",
      "Choisissez le mois, la date ou le statut disponibles. Vérifiez la période affichée avant d’interpréter les totaux.",
      "Ouvrez les détails de la ligne ou son menu de points verticaux, puis l’option d’impression lorsqu’elle est proposée.",
      "Contrôlez l’identité, la référence, les montants et la période dans l’aperçu avant d’imprimer."
    ],
    "tip": "Si une ligne attendue est absente, retirez les filtres et vérifiez la pagination. N’envoyez un document contenant des données personnelles qu’à un destinataire autorisé."
  },
  {
    "id": "medicaments",
    "category": "Catalogue et approvisionnement",
    "title": "Retrouver ou ajouter un médicament",
    "roles": [
      "ROLE_ADMINISTRATEUR",
      "ROLE_PHARMACIEN"
    ],
    "path": "/medicaments",
    "summary": "Organiser les fiches du catalogue sans créer de doublons.",
    "steps": [
      "Ouvrez Médicaments et recherchez l’article avant d’en ajouter un.",
      "Ouvrez la fiche existante ou utilisez l’ajout pour un nouvel article.",
      "Vérifiez le nom, la présentation et les autres informations demandées par le formulaire.",
      "Enregistrez puis retrouvez la fiche dans la liste pour contrôler les informations."
    ],
    "tip": "Créer une fiche de médicament ne crée pas une entrée physique de stock. Les quantités reçues se renseignent dans le parcours d’entrée."
  },
  {
    "id": "consommables",
    "category": "Catalogue et approvisionnement",
    "title": "Gérer les consommables",
    "roles": [
      "ROLE_ADMINISTRATEUR",
      "ROLE_PHARMACIEN"
    ],
    "path": "/consommables",
    "summary": "Retrouver les articles utilisés par les services.",
    "steps": [
      "Ouvrez Consommables et recherchez la désignation.",
      "Ouvrez une fiche ou utilisez l’ajout si l’article n’existe pas.",
      "Renseignez les informations de présentation et de classement demandées.",
      "Relisez les unités puis enregistrez et contrôlez la fiche dans la liste."
    ],
    "tip": "Des unités de conditionnement différentes peuvent entraîner un écart de quantité. Vérifiez toujours l’unité utilisée sur la fiche et sur le mouvement."
  },
  {
    "id": "fournisseurs",
    "category": "Catalogue et approvisionnement",
    "title": "Gérer les fournisseurs",
    "roles": [
      "ROLE_ADMINISTRATEUR",
      "ROLE_PHARMACIEN"
    ],
    "path": "/fournisseurs",
    "summary": "Retrouver les partenaires associés aux approvisionnements.",
    "steps": [
      "Ouvrez Fournisseurs et recherchez le partenaire.",
      "Ouvrez sa fiche ou utilisez l’ajout pour renseigner une nouvelle société.",
      "Complétez les coordonnées et les informations demandées.",
      "Enregistrez puis vérifiez la fiche avant de l’utiliser dans un approvisionnement."
    ],
    "tip": "Évitez les doublons pour conserver un historique cohérent. Vérifiez les coordonnées avant toute commande ou transmission de document."
  },
  {
    "id": "entrees",
    "category": "Catalogue et approvisionnement",
    "title": "Enregistrer une entrée de stock",
    "roles": [
      "ROLE_ADMINISTRATEUR",
      "ROLE_PHARMACIEN"
    ],
    "path": "/entres",
    "summary": "Documenter les articles effectivement reçus.",
    "steps": [
      "Ouvrez Entrées et utilisez le parcours d’ajout.",
      "Choisissez les informations de provenance ou de fournisseur demandées.",
      "Ajoutez les articles et renseignez les quantités reçues ainsi que les lots, dates ou prix proposés par le formulaire.",
      "Comparez les lignes au document de livraison et aux articles physiques avant de confirmer.",
      "Vérifiez l’entrée enregistrée et les quantités obtenues dans les détails."
    ],
    "tip": "N’enregistrez pas deux fois une réception après une interruption réseau : recherchez d’abord sa référence dans les entrées. Une commande attendue n’est pas une réception effective."
  },
  {
    "id": "commandes",
    "category": "Mouvements et délivrance",
    "title": "Consulter et traiter les commandes",
    "roles": [
      "ROLE_ADMINISTRATEUR",
      "ROLE_PHARMACIEN",
      "ROLE_PHARMACIEN_INTERMITENT",
      "ROLE_RECEPTIONNISTE",
      "ROLE_RECEPTIONNISTE_INTERMITENT"
    ],
    "path": "/commandes",
    "summary": "Suivre les demandes avant leur réalisation.",
    "steps": [
      "Ouvrez Commandes et recherchez la référence ou le demandeur.",
      "Vérifiez le statut et les articles demandés.",
      "Ouvrez les détails puis utilisez uniquement les actions proposées à votre rôle.",
      "Contrôlez les quantités et le statut obtenu après l’enregistrement."
    ],
    "tip": "Une demande, une réception et une sortie sont des étapes différentes. Vérifiez le type d’opération avant d’agir sur le stock."
  },
  {
    "id": "ventes-stock",
    "category": "Mouvements et délivrance",
    "title": "Retrouver les ventes à délivrer",
    "roles": [
      "ROLE_ADMINISTRATEUR",
      "ROLE_PHARMACIEN",
      "ROLE_PHARMACIEN_INTERMITENT",
      "ROLE_RECEPTIONNISTE",
      "ROLE_RECEPTIONNISTE_INTERMITENT"
    ],
    "path": "/ventes",
    "summary": "Vérifier les articles d’une vente avant leur délivrance.",
    "steps": [
      "Ouvrez Ventes dans l’interface Stock.",
      "Recherchez la vente et vérifiez le patient ou la référence.",
      "Consultez les articles, les quantités et le statut de l’opération.",
      "Utilisez les actions de délivrance disponibles à votre rôle après vérification des articles physiques.",
      "Contrôlez l’état de la vente et les mouvements associés."
    ],
    "tip": "Ne délivrez pas les articles d’une autre personne portant le même nom. L’encaissement est traité dans la Caisse ; une action de stock ne le remplace pas."
  },
  {
    "id": "sorties",
    "category": "Mouvements et délivrance",
    "title": "Consulter les sorties de stock",
    "roles": [
      "ROLE_ADMINISTRATEUR",
      "ROLE_PHARMACIEN",
      "ROLE_PHARMACIEN_INTERMITENT",
      "ROLE_RECEPTIONNISTE",
      "ROLE_RECEPTIONNISTE_INTERMITENT"
    ],
    "path": "/sorties-de-stock",
    "summary": "Retrouver la destination et le détail des quantités sorties.",
    "steps": [
      "Ouvrez Sorties et choisissez la période recherchée.",
      "Recherchez l’article, la destination ou la référence à contrôler.",
      "Ouvrez les détails de la sortie pour vérifier les quantités et le motif.",
      "Rapprochez le mouvement du document ou de la demande correspondante."
    ],
    "tip": "Un écart de stock doit être vérifié à partir des mouvements. Ne créez pas une sortie de compensation sans en connaître la cause."
  },
  {
    "id": "destockage",
    "category": "Mouvements et délivrance",
    "title": "Préparer un déstockage",
    "roles": [
      "ROLE_ADMINISTRATEUR",
      "ROLE_PHARMACIEN"
    ],
    "path": "/destockages",
    "summary": "Renseigner un mouvement de déstockage avec les articles concernés.",
    "steps": [
      "Ouvrez Stocks → Déstockage et consultez les opérations existantes.",
      "Utilisez le parcours d’ajout, puis choisissez les articles et les informations de destination ou de motif proposées.",
      "Saisissez les quantités en vérifiant les unités et le stock disponible.",
      "Relisez toutes les lignes avant de confirmer, puis contrôlez l’opération dans l’historique."
    ],
    "tip": "Le déstockage modifie les quantités disponibles. Vérifiez le besoin et le motif avant confirmation ; ne l’utilisez pas pour masquer un écart d’inventaire."
  },
  {
    "id": "inventaire-pharmacie",
    "category": "Inventaires",
    "title": "Réaliser un inventaire",
    "roles": [
      "ROLE_PHARMACIEN"
    ],
    "path": "/inventaires",
    "summary": "Comparer le comptage physique aux quantités attendues.",
    "steps": [
      "Ouvrez Inventaires puis Lancer un inventaire, ou reprenez l’inventaire qui vous a été demandé.",
      "Vérifiez le stock, la référence et le statut avant de commencer.",
      "Comptez les articles physiquement et renseignez les quantités dans les unités affichées.",
      "Relisez les écarts et complétez les informations demandées avant de terminer l’étape autorisée.",
      "Retrouvez l’inventaire dans la liste et vérifiez son statut ainsi que les détails."
    ],
    "tip": "Ne remplacez pas le comptage physique par le stock théorique. Un inventaire terminé doit être contrôlé suivant les droits et étapes prévus."
  },
  {
    "id": "inventaire-admin",
    "category": "Inventaires",
    "title": "Demander et contrôler un inventaire",
    "roles": [
      "ROLE_ADMINISTRATEUR"
    ],
    "path": "/inventaires",
    "summary": "Suivre le comptage et examiner les écarts.",
    "steps": [
      "Ouvrez Inventaires et utilisez Demander inventaire pour préparer une demande.",
      "Renseignez le stock et les informations demandées, puis vérifiez la demande créée.",
      "Dans la liste, filtrez par auteur ou période et consultez les statuts.",
      "Ouvrez les détails pour examiner les quantités et les valeurs d’écart.",
      "Utilisez uniquement les actions de contrôle proposées au statut courant."
    ],
    "tip": "Une demande d’inventaire ne remplace pas le comptage. Avant toute décision, vérifiez le stock, l’auteur et la période des résultats."
  },
  {
    "id": "param-stock",
    "category": "Catalogue et approvisionnement",
    "title": "Organiser les types d’articles",
    "roles": [
      "ROLE_ADMINISTRATEUR",
      "ROLE_PHARMACIEN"
    ],
    "path": "/parametres",
    "summary": "Retrouver les réglages de classement du catalogue.",
    "steps": [
      "Ouvrez Paramètres dans l’interface Stock.",
      "Choisissez le type ou la rubrique à configurer.",
      "Recherchez un élément existant avant d’en ajouter un, puis renseignez les informations proposées.",
      "Enregistrez et vérifiez le classement de l’article dans le catalogue."
    ],
    "tip": "Une modification de classement peut affecter les recherches et listes utilisées par l’équipe. Conservez des libellés explicites et évitez les doublons."
  }
]
